import React, { useState, useEffect } from 'react';
  const API_URL = process.env.REACT_APP_API_URL;
export default function VehicleModal({ isOpen, onClose, caseId, item, onSave, exemptions, scope }) {
  const [form, setForm] = useState({
    year: '',
    make: '',
    model: '',
    mileage: '',
    monthlyPayment: '',
    isRecreational: false,
    ownership: '',
    communityProperty: false,
    valueTotal: '',
    valueOwnershipPortion: '',
    otherInfo: '',
    exemptionCode: '',
    exemptionAmount: ''
  });

  useEffect(() => {
    if (item) {
      setForm({
        year: item.year || '',
        make: item.make || '',
        model: item.model || '',
        mileage: item.mileage || '',
        monthlyPayment: item.monthly_payment || '',
        isRecreational: item.is_recreational || false,
        ownership: item.ownership || '',
        communityProperty: item.community_property || false,
        valueTotal: item.value_total || '',
        valueOwnershipPortion: item.value_ownership_portion || '',
        otherInfo: item.other_info || '',
        exemptionCode: item.exemption_code || '',
        exemptionAmount: item.exemption_amount || ''
      });
    } else {
      setForm({
        year: '',
        make: '',
        model: '',
        mileage: '',
        monthlyPayment: '',
        isRecreational: false,
        ownership: '',
        communityProperty: false,
        valueTotal: '',
        valueOwnershipPortion: '',
        otherInfo: '',
        exemptionCode: scope === 'TN' ? '26-2-103' : '',
        exemptionAmount: ''
      });
    }
  }, [item, scope]);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({
      ...f,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const url = item
      ? `${API_URL}/case/${caseId}/vehicles/${item.id}/`
      : `${API_URL}/case/${caseId}/vehicles/`;
    const method = item ? 'PUT' : 'POST';
    const payload = {
      year: form.year,
      make: form.make,
      model: form.model,
      mileage: form.mileage,
      monthly_payment: form.monthlyPayment,
      is_recreational: form.isRecreational,
      ownership: form.ownership,
      community_property: form.communityProperty,
      value_total: form.valueTotal,
      value_ownership_portion: form.valueOwnershipPortion,
      other_info: form.otherInfo,
      exemption_code: form.exemptionCode,
      exemption_amount: form.exemptionAmount
    };
    const res = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
      },
      body: JSON.stringify(payload)
    });
    if (res.ok) {
      const saved = await res.json();
      onSave(saved);
      onClose();
    } else {
      alert('Failed to save vehicle.');
    }
  };

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white p-3 rounded-lg w-full max-w-xl mx-auto">
        <h3 className="text-xl font-semibold mb-4">
          {item ? 'Edit Vehicle' : 'Add Vehicle'}
        </h3>
        <form onSubmit={handleSubmit} className="space-y-2">
          {/* Year, Make, Model */}
          <div className="grid grid-cols-12 gap-2">
            <div className="col-span-2">
              <label className="block text-sm mb-1">Year</label>
              <input
                name="year" type="number" value={form.year}
                onChange={handleChange}
                className="block w-full border p-2 rounded"
              />
            </div>
            <div className="col-span-5">
              <label className="block text-sm mb-1">Make</label>
              <input
                name="make" value={form.make}
                onChange={handleChange}
                className="block w-full border p-2 rounded"
              />
            </div>
            <div className="col-span-5">
              <label className="block text-sm mb-1">Model</label>
              <input
                name="model" value={form.model}
                onChange={handleChange}
                className="block w-full border p-2 rounded"
              />
            </div>
          </div>

          {/* Mileage, Monthly Payment, Value Total, Value Ownership */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-1">
            <div>
              <label className="block text-sm mb-1">Mileage</label>
              <input
                name="mileage" type="number" value={form.mileage}
                onChange={handleChange}
                className="block w-full border p-2 rounded"
              />
            </div>
            <div>
              <label className="block text-sm mb-1">Monthly Payment</label>
              <input
                name="monthlyPayment" type="number" step="0.01" value={form.monthlyPayment}
                onChange={handleChange}
                className="block w-full border p-2 rounded"
              />
            </div>
            <div>
              <label className="block text-sm mb-1">Value (Total)</label>
              <input
                name="valueTotal" type="number" step="0.01" value={form.valueTotal}
                onChange={handleChange}
                className="block w-full border p-2 rounded"
              />
            </div>
            <div>
              <label className="block text-sm mb-1">Value (Ownership)</label>
              <input
                name="valueOwnershipPortion" type="number" step="0.01" value={form.valueOwnershipPortion}
                onChange={handleChange}
                className="block w-full border p-2 rounded"
              />
            </div>
          </div>

          {/* Ownership, Community Property, Recreational */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            <div>
              <label className="block text-sm mb-1">Ownership</label>
              <select
                name="ownership" value={form.ownership} onChange={handleChange}
                className="block w-full border p-2 rounded"
              >
                <option value="">Select…</option>
                <option value="debtor1">Debtor 1</option>
                <option value="debtor2">Debtor 2</option>
                <option value="d1_d2">Debtor 1 &amp; Debtor 2</option>
                <option value="joint_third">Joint with Third Party</option>
              </select>
            </div>
            <div className="flex items-center space-x-4">
              <input
                name="communityProperty" type="checkbox"
                checked={form.communityProperty} onChange={handleChange}
                className="mt-1"
              />
              <label className="text-sm mb-1">Community Property</label>
              <input
                name="isRecreational" type="checkbox"
                checked={form.isRecreational} onChange={handleChange}
                className="ml-6 mt-1"
              />
              <label className="text-sm mb-1">Recreational Vehicle</label>
            </div>
          </div>

          {/* Exemption and Amount */}
          <div className="grid grid-cols-12 gap-1">
            <div className="col-span-8">
              <label className="block text-sm mb-1">Exemption</label>
              <select
                name="exemptionCode" value={form.exemptionCode}
                onChange={handleChange}
                className="block w-full border p-2 rounded"
              >
                <option value="">Select exemption…</option>
                {exemptions.map(ex => (
                  <option key={ex.key} value={ex.law}>
                    {ex.asset_name} (${parseFloat(ex.limit).toFixed(2)})
                  </option>
                ))}
              </select>
            </div>
            <div className="col-span-4">
              <label className="block text-sm mb-1">Exemption Amount</label>
              <input
                name="exemptionAmount" type="number" step="0.01"
                value={form.exemptionAmount} onChange={handleChange}
                className="block w-full border p-2 rounded"
              />
            </div>
          </div>

          <label className="block text-sm mb-1">Other Info</label>
          <textarea
            name="otherInfo"
            value={form.otherInfo}
            onChange={handleChange}
            rows="3"
            className="block w-full border p-2 rounded mb-2"
          />

          <div className="flex justify-end space-x-2 mt-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
